import { useContext } from "react"

import { SerialContext } from "src/components/RemoteDebugService/SerialContext"

export function useSerial(props?: { autoConnectEnabled?: boolean }) {
  const serialContext = useContext(SerialContext)
  if (props?.autoConnectEnabled) serialContext.setAutoConnectEnabled(true)
  return serialContext
}
